import { render, staticRenderFns } from "./verification-confirm-nulled.vue?vue&type=template&id=222342a1&"
import script from "./verification-confirm-nulled.vue?vue&type=script&lang=js&"
export * from "./verification-confirm-nulled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports